<input
  class="input-search"
  [ngClass]="searchFieldClass"
  (keyup)="touchApplyFilter($event)"
  [placeholder]="placeholder"
  [value]="filterValue"
>
